import { useTranslation } from "react-i18next";
import { PageLayout } from "../../Components/PageLayout";
import { VehicleTabs } from "../../Components/Tables/Vehicles/Tabs";
import { useState } from "react";
import InventoryTable from "./Table";
import instance from "../../Interceptor/api_instance";
import { Spinner } from "../../Components/LoadingAnimations/LoadingAnimations";

const InventoryView = () => {
  const [location, setLocation] = useState("San Diego");
  const [requestLoading, setRequestLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const exportData = async () => {
    setRequestLoading(true);
    setError(null);
    setMessage(null);
    try {
      await instance.post("files/export-inventory-reports");
      setMessage("Inventory export job has been created successfully.");
    } catch {
      setError("Failed to export inventory data.");
    } finally {
      setRequestLoading(false);
    }
  };
  const { t } = useTranslation();
  return (
    <PageLayout title={"Inventory"}>
      {error && <p className="error">{error}</p>}
      {message && <p className="success">{message}</p>}
      <div className="overview-header flex-2">
        <h1 className="global-h2 black margin-bottom-24 ">
          {t("page-headers.inventory")}
        </h1>
        {requestLoading ? (
          <Spinner />
        ) : (
          <button className="all-btn cancel-btn" onClick={() => exportData()}>
            {t("buttons.export")}
          </button>
        )}
      </div>
      <VehicleTabs
        tabs={["San Diego", "Tijuana", "Toyota", "Velocity", "Mexicali"]}
        selectedTab={location}
        setSelectedTab={setLocation}
      />

      <InventoryTable location={location} />
    </PageLayout>
  );
};

export default InventoryView;
